// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"css--8Be0TtfzR","table__measurementChart":"css-3QcfFWnjih","table__sizeGuide":"css-H1kJQFlgFf","matchingSize":"css-2OsddYA-u1"};